import { Component, OnInit, Input } from '@angular/core';
import { onSideNavChange, animateText } from '../../animations/animations';
import { SidenavService } from '../../services/sidenav.service';
import { MatSidenav } from '@angular/material/sidenav';
import { MediaObserver, MediaChange } from '@angular/flex-layout';
import { Page } from '../../interfaces/page.interface';
import { TranslateService } from '@ngx-translate/core';
import { Organization } from '../../interfaces/organization-info.interface';
import { User } from '../../models/user.model';
import { Course } from '../../models/course.model';
import { AuthService } from '../../services/auth.service';
import { Router } from '@angular/router';
import { map } from 'rxjs/operators';
import { SpinnerService } from '../../services/spinner.service';
import {
  AngularFireDatabase,
  AngularFireList,
  AngularFireObject,
} from '@angular/fire/database';
import { formatDate } from '@angular/common';

@Component({
  selector: 'app-left-menu',
  templateUrl: './left-menu.component.html',
  styleUrls: ['./left-menu.component.css'],
  animations: [onSideNavChange, animateText],
})
export class LeftMenuComponent implements OnInit {
  public sideNavState: boolean = true;
  public linkText: boolean = true;
  public showLogo: boolean = true;
  public showColorBtn: boolean = false;
  users: [];
  user_id: string;
  userdata = null;
  userList: AngularFireList<any>;
  dateNow: Date = new Date();

  //GPT data
  public gptwebskcount: number; //count
  public gptpaidwebskint: number; //limit
  public gptmaxwebskint:Number;
  public gptendsubscriptiondate: string; //endsubscription
  public gptrenewdate: string; //renewdate
  public gptsubscriptiondate: string; //date of subscription
  public gptpayedsubscription: boolean; //pagó
  public gptforcedeactivate: boolean; //usuario desactivado
  public gptforcedeactivateall: boolean; //servicio desactivado
  ft: boolean =true

  public pages: Page[] = [
    { name: 'SIDENAV.MENU.PROFILE', link: './profile', icon: 'account_box' },
    { name: 'SIDENAV.MENU.COURSES', link: './courses', icon: 'school' },
    { name: 'SIDENAV.MENU.LESSONS', link: './lessons', icon: 'library_books' },
    {
      name: 'SIDENAV.MENU.ACTIVITIES',
      link: './lessons/activities',
      icon: 'content_paste',
    },
    {
      name: 'SIDENAV.MENU.PUBLIC_ACTIVITIES',
      link: './lessons/public-activities',
      icon: 'archive',
    },
    /* { name: 'SIDENAV.MENU.DASHBOARD', link: './dashboard', icon: 'dashboard' } */
    /* { name: 'SIDENAV.MENU.USERS', link: './users', icon: 'person' } */
  ];

  public pages2: Page[]=[
    { name: 'Upgrade', link: './auth/payments', icon: 'monetization_on' }
  ];

  public classesList = [
    'Clase 1',
    'Clase 2',
    'Clase 3',
    'Clase 4',
    'Clase 5',
    'Clase 6',
    'Clase 7',
    'Clase 8',
  ];

  /* public categories: Category[] = [
    { name: 'SIDENAV.CATEGORIES.OWN', icon: 'assignment_ind', color: 'primary' },
    { name: 'SIDENAV.CATEGORIES.LESSONS', icon: 'label', color: 'accent' },
    { name: 'SIDENAV.CATEGORIES.ACTIVITIES', icon: 'label', color: 'warn' },
    { name: 'SIDENAV.CATEGORIES.SEARCHED', icon: 'label', color: 'grey' },
  ]; */

  @Input() user: User;
  @Input() mainOrganization: Organization;
  @Input() organizations: Organization[];

  @Input() sidenav: MatSidenav;

  constructor(
    private _sidenavService: SidenavService,
    private watcher: MediaObserver,
    public auth: AuthService,
    private translate: TranslateService,
    private spinner: SpinnerService,
    private router: Router,
    private angularFireDatabase: AngularFireDatabase
  ) {}

  ngOnInit() {
    console.log(this.auth.currentUser);
    if (this.auth.currentUser.isSuperuser || this.auth.currentUser.isOrgAdmin) {
      this.showColorBtn = true;
      this.pages.push({
        name: 'SIDENAV.MENU.ORG_ACTIVITIES',
        link: './lessons/org_activities',
        icon: 'folder',
      });
      this.pages.push({
        name: 'SIDENAV.MENU.USERS',
        link: './users',
        icon: 'people',
      });
      this.pages.push({
        name: 'SIDENAV.MENU.ACTIVITY_COPY',
        link: './lessons/activity-copy',
        icon: 'content_copy',
      });
      //this.pages.push({ name: 'SIDENAV.MENU.PUBLIC_ACTIVITIES', link: './lessons/public-activities', icon: 'content_paste' },)
    
    }

    if (this.watcher.isActive('xs') || this.watcher.isActive('sm')) {
      this.showLogo = false;
    }

    this.watcher.media$.subscribe((change: MediaChange) => {
      switch (change.mqAlias) {
        case 'xs':
        case 'sm':
          this.showLogo = false;
          break;
        default:
          this.showLogo = true;
          break;
      }
    });
    this.getAlldata();
  }

  logout() {
    this.spinner.showSpinner = true;
    this.auth.logout();

    /* if (this.router.url !== '/auth/login') {
      this.router.navigate(['/auth/login']);
    } */
  }

  onSidenavToggle() {
    this.sideNavState = !this.sideNavState;
    this.linkText = this.sideNavState;
    /* setTimeout(() => {
      this.linkText = this.sideNavState;
    }, 1) */
    this._sidenavService.sideNavState$.next(this.sideNavState);
  }

  setLanguages(lang: string): void {
    this.spinner.showSpinner = true;
    setTimeout(() => {
      this.translate.use(lang).subscribe(() => {
        this.spinner.showSpinner = false;
      });
    }, 500);
  }

  getAlldata() {
    //console.log(this.angularFireDatabase.list('/'));
    this.userList = this.angularFireDatabase.list('GPTcheck');
    this.userList.snapshotChanges().subscribe((data: any) => {
      this.users = data.map((e) => {
        const userid = e.key;
        const dataobj = e.payload.val();
        //console.log(userid,dataobj)
        return { key: e.key, dta: dataobj };
      });
    });
    setTimeout(() => {
      this.getUserdata();
    }, 3000);
  }

  getUserdata() {
    //this useer error
    if(this.users===undefined && this.ft){
      this.ft=false
      this.getAlldata()
      console.log("no cargo los datos intentando nuevamente")
    }
    else{
      this.ft=true
    console.log(this.users);
    this.user_id = this.auth.currentUser.id.toString();
    let obj: any = this.users.filter((x: any) => {
      if(x.key=='deactivate4all')
        this.gptforcedeactivateall=x.dta
      if(x.key=='max-webskinteraction')
        this.gptmaxwebskint =x.dta
      if (x.key == 'users') {
        var listusers = x.dta;
        //console.log(listusers[this.user_id]);
        return listusers[this.user_id];
      }
    });
    localStorage.setItem('gptforcedeactivateall',this.gptforcedeactivateall.toString())
    localStorage.setItem('gptmaxwebskint',this.gptmaxwebskint.toString())
    var now = new Date();
    //console.log(now.getMonth());
    if (now.getMonth() == 11) {
      var current = new Date(now.getFullYear() + 1, 0, now.getDay());
    } else {
      var current = new Date(
        now.getFullYear(),
        now.getMonth() + 1,
        now.getDay()
      );
    }

    if (obj[0] === undefined) {
      console.log(this.user_id, 'usuario no existe asi que le crearemos datos');
      this.userList.update('users/' + this.user_id, {
        'ChatGPT-activated': {
          date: formatDate(now, 'MM/dd/yyyy', 'en-EN'),
          isactivated: true,
        },
        count: 0,
        forcedeactivate: false,
        isactive: false,
        lastinterationdate: Date.parse(now.toDateString()),
        paid: {
          endsubscription: formatDate(current, 'MM/dd/yyyy', 'en-EN'),
          paidinteraction: 500,
          paidwebskint: 100,
          payed: false,
          renewdate: formatDate(now, 'MM/dd/yyyy', 'en-EN'),
          subscriptiondate: formatDate(now, 'MM/dd/yyyy', 'en-EN'),
        },
        webskcount: 0,
      });
      this.gptwebskcount = 0;
      this.gptsubscriptiondate = formatDate(now, 'MM/dd/yyyy', 'en-EN');
      this.gptpaidwebskint = 100
      this.gptrenewdate = formatDate(now, 'MM/dd/yyyy', 'en-EN');
      this.gptendsubscriptiondate = formatDate(current, 'MM/dd/yyyy', 'en-EN');
      localStorage.setItem('gptwebskcount',this.gptwebskcount.toString())
      localStorage.setItem('gptsubscriptiondate',this.gptsubscriptiondate.toString())
      localStorage.setItem('gptrenewdate',this.gptrenewdate.toString())
      localStorage.setItem('gptendsubscriptiondate',this.gptendsubscriptiondate.toString())
      localStorage.setItem('gptforcedeactivate',this.gptforcedeactivate.toString())
      localStorage.setItem('gptpaidwebskint',this.gptpaidwebskint.toString())
    } else {
      if(obj[0].dta[this.user_id]['webskcount'])
      this.gptwebskcount = Number(obj[0].dta[this.user_id]['webskcount']);
      else
      this.gptwebskcount=0
      this.gptsubscriptiondate =
        obj[0].dta[this.user_id]['paid']['subscriptiondate'];
      this.gptrenewdate = obj[0].dta[this.user_id]['paid']['renewdate'];
      this.gptendsubscriptiondate =
        obj[0].dta[this.user_id]['paid']['endsubscription'];
      this.gptpayedsubscription = obj[0].dta[this.user_id]['paid']['payed'];
      this.gptforcedeactivate = obj[0].dta[this.user_id]['forcedeactivate'];
      if(obj[0].dta[this.user_id]['paid']['paidwebskint'])
        this.gptpaidwebskint=obj[0].dta[this.user_id]['paid']['paidwebskint']
      else{
        this.gptpaidwebskint=100
        this.userList.update('users/', {
          [this.user_id + '/paid/paidwebskint']: this.gptmaxwebskint,
        });
      }
      console.log(this.gptpaidwebskint)
      this.userList.update('users/', {
        [this.user_id + '/lastinterationdate']: Date.parse(now.toDateString()),
      });
      localStorage.setItem('gptwebskcount',this.gptwebskcount.toString())
      localStorage.setItem('gptsubscriptiondate',this.gptsubscriptiondate.toString())
      localStorage.setItem('gptrenewdate',this.gptrenewdate.toString())
      localStorage.setItem('gptendsubscriptiondate',this.gptendsubscriptiondate.toString())
      localStorage.setItem('gptpayedsubscription',this.gptpayedsubscription.toString())
      localStorage.setItem('gptforcedeactivate',this.gptforcedeactivate.toString())
      localStorage.setItem('gptpaidwebskint',this.gptpaidwebskint.toString())
      console.log(Date.parse(now.toDateString()))
      console.log(this.user_id, obj[0].dta[this.user_id]);
    }
  }
}
}
